import { NbModal, makeUclComponent } from '@fhs-legacy/universal-components';

const ModalHeading = makeUclComponent(NbModal.Header).withConfig({
  _text: {
    textAlign: 'center',
    fontFamily: 'heading',
    accessibilityRole: 'header',
    // @ts-expect-error TS(2322) FIXME: Type '{ textAlign: "center"; fontFamily: string; a... Remove this comment to see the full error message
    accessibilityLevel: '2',
    fontWeight: 'normal',
    fontSize: '4xl',
    color: 'black',
    letterSpacing: '-0.42px',
    maxWidth: {
      desktop: '500px',
    },
  },
});

export default ModalHeading;
